export const generateQueryString = (query: Record<string, string> | string | undefined) => {
    if (!query) {
        return '';
    }
    if (typeof query === 'string') {
        return `?${query}`;
    }
    return `?${new URLSearchParams(query)}`;
};
